import styles from "../index.less";
import Blank from "../components/blank";
import icon_right from "../../../asset/img/login/icon_right.png";
import fillJsfImage from "utils/fillJsfImages";
import { queryDoctorList, querySeoDoctorList } from "api/hospital";
import { useEffect, useState } from "react";
import { onClickhref } from "utils";
import { departNav, hospitalNav } from "utils/hospital";

const RecommandDoctor = ({ tabIndex, pageId, name, departId }: any) => {
  const moreUrl = departId ? departNav(`${pageId}-${departId}`)[tabIndex]?.url : hospitalNav(pageId)[tabIndex]?.url;
  const [data, setData] = useState<any>([]);
  useEffect(() => {

    getDoctorList(pageId);
  }, []);
  // 获取医生列表
  const getDoctorList = (hospitalId: any) => {
    const func = departId ? querySeoDoctorList : queryDoctorList
    const param: any = {
      channel:1,
      pageIndex:1,
      pageSize:20,
      keyWords:{
        hospitalId,
        secondDepartmentId: departId
      },
    }
    if (departId) {
      param.keyWords.businessSource = 'seo';
    }
    func(param).then((res: any) => {
      setData(res.doctorList || []);
    })
  }
  if(!data?.length){
    return null;
  }
  return <Blank className={styles.recommandDoctor} title={`${name || '' }推荐医生`} moreUrl={moreUrl}>
    {data?.length > 0 ?
      <div className={styles.content}>
        {
          data.map((item: any, index: number) => (
            <div onClick={() => onClickhref(`/doctor/${item.doctorId}`)} className={`${styles.doctor} ${index >= 10 ? styles.displayNone : ''}` } key={item.doctorId}>
              <div className={styles.avtor}>
                <img src={fillJsfImage(item.doctorInfo.doctorHeadPic)} alt={item?.doctorInfo?.doctorName} />
              </div>
              <span className={styles.h4} data-a-href={`/doctor/${item.doctorId}`}>{item?.doctorInfo?.doctorName}</span>
              <p>{item?.doctorInfo?.doctorTitleName}</p>
              <p className={styles.hospitalName}>{item?.hospitalInfo?.hospitalName}</p>
              <p className={styles.goodAt}>好评率：<span>{item?.feedbackInfo?.patientEvaluationRate || '暂无'}</span></p>
              <div className={styles.btn}>立即咨询<img src={icon_right} /></div>
              <div className={styles.displayNone}>{item?.goodAtInfo?.doctorGoodAtDesc}{item?.goodAtInfo?.doctorGoodAt}</div>
            </div>
          ))
        }
      </div>
    : <div className={styles.noData}>{departId ? '暂无科室医生' : '暂无推荐医生'}</div>
  } 
</Blank>
}
export default RecommandDoctor;